import React from 'react';
import { Info, X } from 'lucide-react';

/**
 * InlineNotice — a gentle, non-blocking notice bar shown beneath the toolbar.
 * Used for transient guidance (e.g. "mark your lines first"). Auto-dismiss is
 * handled by the caller; a manual close button is also provided.
 *
 * @param {object} props
 * @param {string} props.message - the text to display
 * @param {function} props.onDismiss - called when the user closes the notice
 */
export default function InlineNotice({ message, onDismiss }) {
  if (!message) return null;

  return (
    <div className="inline-notice" role="status">
      <Info size={14} className="inline-notice-icon" />
      <span className="inline-notice-text">{message}</span>
      <button
        className="inline-notice-close"
        onClick={onDismiss}
        title="Dismiss"
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
